<template>
  <div
    class="list-item"
    :class="{
      'list-item--large': size === 'large',
      'list-item--small': size === 'small',
      'multiline-subtitles': !!subtitle && !!subtitleTwo,
    }"
  >
    <div class="list-item__left-icon" :style="{ backgroundColor: iconColor }">
      <slot name="left-icon"></slot>
    </div>

    <div class="list-item__content">
      <div class="list-item__title">{{ title }}</div>
      <div class="list-item__subtitle" v-if="subtitle">{{ subtitle }}</div>
      <div class="list-item__subtitle" v-if="subtitleTwo">
        {{ subtitleTwo }}
      </div>
    </div>

    <div
      class="list-item__right-icon"
      v-if="hasRightIcon"
      :style="{ backgroundColor: iconColor }"
    >
      <slot name="right-icon"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ListComponent',

  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    subtitleTwo: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'large',
      validator: (value: string) => ['large', 'small'].includes(value),
    },
    iconColor: {
      type: String,
      default: '#FFBFE7',
    },
    hasRightIcon: {
      type: Boolean,
      default: true,
    },
  },
});
</script>

<style scoped>
.list-item {
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  width: 100%;
  position: relative;
}

.list-item__left-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.list-item__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.list-item__title {
  font-family: 'Jost', sans-serif;
  font-weight: 500;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-item__subtitle {
  font-family: 'Jost', sans-serif;
  font-weight: 400;
  color: #757575;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-item__right-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.list-item--large {
  height: 78px;
  padding: 16px;
  gap: 12px;
}

.list-item--large .list-item__left-icon {
  width: 32px;
  height: 32px;
  gap: 10px;
}

.list-item--large .list-item__content {
  width: 248px;
  height: 46px;
}

.list-item--large .list-item__right-icon {
  width: 24px;
  height: 24px;
  gap: 6.67px;
}

.list-item--large .list-item__title {
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
}

.list-item--large .list-item__subtitle {
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0px;
}

.list-item--small {
  height: 63px;
  padding: 12px 16px;
  gap: 12px;
}

.list-item--small .list-item__left-icon {
  width: 28px;
  height: 28px;
  border-width: 0.44px;
  gap: 8.75px;
}

.list-item--small .list-item__content {
  width: 258px;
  height: 39px;
}

.list-item--small .list-item__right-icon {
  width: 18px;
  height: 18px;
  gap: 4.29px;
}

.list-item--small .list-item__title {
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0px;
}

.list-item--small .list-item__subtitle {
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0px;
}

.list-item--large.multiline-subtitles {
  height: 100px;
}

.list-item--large.multiline-subtitles .list-item__content {
  width: 248px;
  height: 68px;
}

.list-item--small.multiline-subtitles {
  height: 81px;
}

.list-item--small.multiline-subtitles .list-item__content {
  width: 258px;
  height: 57px;
}

@media (max-width: 360px) {
  .list-item {
    width: 100%;
  }

  .list-item__content {
    width: auto;
  }
}
</style>
